import { render, staticRenderFns } from "./Districts.vue?vue&type=template&id=d1d53a5a&scoped=true&"
import script from "./Districts.vue?vue&type=script&lang=js&"
export * from "./Districts.vue?vue&type=script&lang=js&"
import style0 from "./Districts.vue?vue&type=style&index=0&id=d1d53a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d53a5a",
  null
  
)

export default component.exports